@if ({ state: state$ | async }; as states) {
  <span class="lens-icon">
    <img src="/assets/images/svg/search.svg" />
  </span>
  <bp-input
    [model]="model"
    [placeholder]="placeholder"
    [displayLogo]="true"
    [label]="label"
    [type]="'text'"
    (focusout)="handleFocusOut()"
    (onInputModified)="updateHasInput($event)"
    (inputGroupEvent)="inputGroup = $event">
  </bp-input>
  <!-- Loading -->
  @if (!states.state.searchFinished && hasInput) {
    <div class="loading-container">
      <div class="loading-spinner">
        <loading-spinner></loading-spinner>
      </div>
      <span>{{ "autofill_city_searching" | translate }}</span>
    </div>
  } @else {
    <!-- Results -->
    @if (predictions.length > 0 && showSuggestions) {
      <div class="flex flex-col flag-on-maps-result-container width-address-search">
        @for (result of predictions; track result) {
          <div
            class="flag-on-maps-result-item"
            (mousedown)="searchResultClick(result, $event)">
            <div class="flex flex-col text">
              <span
                [baseText]="result.structured_formatting.main_text"
                [appHighlight]="inputGroup.nativeElement.value"
                class="main_text">
                {{ result.structured_formatting.main_text }}
              </span>
              <span class="secondary_text">
                {{ result.structured_formatting.secondary_text }}
              </span>
            </div>
          </div>
        }
      </div>
    }
    <!-- No results -->
    @if (predictions.length === 0 && hasInput && showSuggestions) {
      <div class="address-no-suggestion-box">
        <div class="address-no-suggestion-box-item flex flex-col">
          <span class="no-found-main">
            {{ "autofill_city_not_found_title" | translate }}
          </span>
        </div>
      </div>
    }
  }
}
